"use client";

import React from "react";
import { Leaf, WheatOff, Fish, ShieldCheck, Rabbit, Diamond, Truck, BottleWine, Wheat, Footprints } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const sealsData = [{
  id: "pharma",
  label: "pharma",
  description: "Strategic sourcing solutions for pharmaceutical packaging and supply chain compliance.",
  iconName: "ShieldCheck"
}, {
  id: "chemicals",
  label: "chemicals",
  description: "Expert procurement for chemical industrial packaging and hazardous material logistics.",
  iconName: "Leaf"
}, {
  id: "cosmetics",
  label: "cosmetics",
  description: "Premium sourcing for luxury cosmetic containers and sustainable beauty packaging.",
  iconName: "BottleWine"
}, {
  id: "food-beverage",
  label: "food & beverage",
  description: "Cost reduction strategies for high-volume food grade plastics, glass, and metals.",
  iconName: "Wheat"
}, {
  id: "consumer-goods",
  label: "consumer goods",
  description: "Optimizing corrugated and solid board packaging for fast-moving consumer products.",
  iconName: "Footprints"
}, {
  id: "luxury",
  label: "luxury",
  description: "Bespoke procurement for high-end luxury goods and premium brand packaging.",
  iconName: "Diamond"
}, {
  id: "logistic",
  label: "logistic",
  description: "Streamlining global supply chains and optimizing freight for maximum efficiency.",
  iconName: "Truck"
}];
const getIcon = (name: string) => {
  switch (name) {
    case "Leaf":
      return Leaf;
    case "WheatOff":
      return WheatOff;
    case "Wheat":
      return Wheat;
    case "Fish":
      return Fish;
    case "ShieldCheck":
      return ShieldCheck;
    case "Rabbit":
      return Rabbit;
    case "BottleWine":
      return BottleWine;
    case "Diamond":
      return Diamond;
    case "Truck":
      return Truck;
    case "Footprints":
      return Footprints;
    default:
      return Leaf;
  }
};
export default function Industryiconrow() {
  return <section data-section-id="223840" id="industryiconrow" className="w-full border-y border-border py-8 md:py-10 overflow-hidden light bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <TooltipProvider delayDuration={100}>
          <div className="flex flex-wrap justify-center items-start gap-8 md:gap-12 lg:gap-20">
            {sealsData.map((seal, i) => {
            const Icon = getIcon(seal.iconName);
            return <div key={seal.id} data-index={i} className="flex-shrink-0">
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="group flex flex-col items-center gap-3 cursor-help focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-md p-2">
                        <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-background shadow-sm border border-border transition-transform duration-300 ease-out group-hover:scale-105 group-hover:shadow-md">
                          <Icon className="size-6 text-primary transition-colors duration-300" strokeWidth={2} aria-hidden="true" />
                        </div>
                        <span className="font-default text-xs md:text-sm font-medium text-primary lowercase tracking-normal text-center max-w-[120px] leading-tight">
                          {seal.label}
                        </span>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent side="bottom" align="center" className="max-w-[220px] text-center p-3 shadow-lg bg-popover text-popover-foreground border-border" sideOffset={8}>
                      <p className="text-sm font-default leading-relaxed">
                        {seal.description}
                      </p>
                    </TooltipContent>
                  </Tooltip>
                </div>;
          })}
          </div>
        </TooltipProvider>
      </div>
    </section>;
}